"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var react_is_1 = tslib_1.__importDefault(require("react-is"));
var config_provider_1 = tslib_1.__importDefault(require("./config-provider"));
function withAnq(Component, _a) {
    var onInit = _a.onInit, config = _a.config, _b = _a.OriginComponent, OriginComponent = _b === void 0 ? Component : _b;
    var displayName = Component.displayName || Component.name || 'Component';
    var ComponentWithAnq = react_1.default.forwardRef(function (props, ref) {
        var dProps = onInit ? onInit(props) : {};
        return config ? (react_1.default.createElement(config_provider_1.default, tslib_1.__assign({}, config),
            react_1.default.createElement(Component, tslib_1.__assign({}, props, dProps, { ref: ref })))) : (react_1.default.createElement(Component, tslib_1.__assign({}, props, dProps, { ref: ref })));
    });
    Object.keys(OriginComponent).forEach(function (key) {
        var originValue = OriginComponent[key];
        if (ComponentWithAnq[key]) {
            return;
        }
        if (react_is_1.default.isElement(originValue) &&
            !/^withAnq/.test(originValue.displayName)) {
            ComponentWithAnq[key] = withAnq(originValue, {
                config: { prefixCls: 'anq' },
            });
        }
        else {
            ComponentWithAnq[key] = originValue;
        }
    });
    ComponentWithAnq.displayName = "withAnq(".concat(displayName, ")");
    return ComponentWithAnq;
}
exports.default = withAnq;
//# sourceMappingURL=widthAnq.js.map